import  {ActionTypes}  from "../constants/ActionTypes";
const intialState = [];
const defaultCategoryTotalRecordsCount = 0;

export const categoryReducers = (state = intialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_CATEGORIES:
      return payload;
    default:
      return state;
  }
};

export const categoryTotalRecordsCountReducers = (state = defaultCategoryTotalRecordsCount, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_CATEGORY_TOTAL_COUNT:
      return payload;
    default:
      return state;
  }
};